import * as React from 'react';
import SupportPageView from '../layouts/SupportPageView';
import { GetSupportMessage } from 'src/reducers/supportPage';
// import { Snackbar } from '@material-ui/core';
// import { Alert, AlertTitle } from '@material-ui/lab';
// import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
// import Button from '@material-ui/core/Button';

// function Alert(props: AlertProps) {
//   return <MuiAlert elevation={6} variant="filled" {...props} />;
// }
export interface SupportPageprops {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  getSupportMessage: GetSupportMessage[];
  customer: string;
  messaging: (message: string) => void;
  messages: string;
  onSubmit: () => void;
  goToFeedback: () => void;
  onFilesChange: (messageFiles: Array<File>) => void;
  onFilesError: (error: Error, images: Array<File>) => void;
  msgAtt: (msgAttachment: string, ociStatus: string) => void;
  saveStatusType: (statustype: string) => void;
  ticketno: string;
  status: string;
  date: string;
  supporttype: string;
  mtype: string;
  messageFiles: File[];

  // errorMessage: string;
  // errorBar: boolean;
  // successMessage: string;
  // successBar: boolean;
  // handleClose: () => void;

  // message: string;
}

class SupportPage extends React.Component<SupportPageprops> {
  render() {
    return (
      <div>
        <SupportPageView
          // getMessage={this.props.getMessage}
          getSupportMessage={this.props.getSupportMessage}
          customer={this.props.customer}
          messaging={this.props.messaging}
          onSubmit={this.props.onSubmit}
          messages={this.props.messages}
          onFilesChange={this.props.onFilesChange}
          onFilesError={this.props.onFilesError}
          // getApiMessage={this.props.getApiMessage}
          msgAtt={this.props.msgAtt}
          ticketno={this.props.ticketno}
          status={this.props.status}
          date={this.props.date}
          supporttype={this.props.supporttype}
          mtype={this.props.mtype}
          saveStatusType={this.props.saveStatusType}
          goToFeedback={this.props.goToFeedback}
          messageFiles={this.props.messageFiles}
        // message={this.props.message}
        />
        {/* <Snackbar
          open={this.props.errorBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="error"
          >
            <AlertTitle>Error</AlertTitle>
            {this.props.errorMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={this.props.successBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="success"
          >
            <AlertTitle>Success</AlertTitle>
            {this.props.successMessage}
          </Alert>
        </Snackbar> */}
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
  componentWillUnmount() {
    this.props.onFilesChange([]);
  }
}

export default SupportPage;



// WEBPACK FOOTER //
// ./src/components/supportPage/SupportPage.tsx